export default "__VITE_ASSET__ME5eeWBE__"